// Источники конфигурации фронтенда (справочник — docs/configuration-env.md):
// 1. window._env_ — runtime-конфиг контейнера: при старте nginx скрипт
//    docker-entrypoint.d/40-cabinet-env-config.sh пишет в public/env-config.js переменные
//    CABINET_REACT_APP_* (префикс CABINET_ срезается);
// 2. process.env.REACT_APP_* — CRA на этапе сборки / npm start (.env.development.local, см. .env.example);
// 3. прежний хардкод — fallback, поведение без переменных не меняется.
// В dev public/env-config.js пуст (window._env_ = {}), поэтому работает как раньше.
const runtimeEnv: Record<string, string | undefined> =
    (typeof window !== 'undefined' && window._env_) || {};

// process.env.REACT_APP_* передаётся из места вызова статическим обращением: CRA подставляет
// значения только для явных process.env.REACT_APP_X.
const readEnv = (name: string, buildValue: string | undefined): string | undefined =>
    runtimeEnv[name] || buildValue || undefined;

const readEnvNumber = (name: string, buildValue: string | undefined, fallback: number): number => {
    const value = Number(readEnv(name, buildValue));
    return Number.isFinite(value) && value > 0 ? value : fallback;
};

const getApiBaseUrl = () => {
    // Явный override из окружения — для контейнера и локального dev/e2e (см. .env.example).
    // Если переменная не задана — поведение прежнее (хардкод сохраняется как fallback).
    const configured = readEnv('REACT_APP_API_URL', process.env.REACT_APP_API_URL);
    if (configured) {
        return configured;
    }

    const hostname = window.location.hostname;

    if (hostname.startsWith('10.') || hostname.startsWith('192.168.') || hostname === 'localhost') {
        return 'http://10.10.1.1:5000/';
    }

    const protocol = window.location.protocol; // 'http:' или 'https:'
    return `${protocol}//cabinet.bga.gov.kg/`;
};

const getApiBaseUrlBga = () => {
    const configured = readEnv('REACT_APP_API_URL_BGA', process.env.REACT_APP_API_URL_BGA);
    if (configured) {
        return configured;
    }

    const hostname = window.location.hostname;

    if (hostname.startsWith('10.') || hostname.startsWith('192.168.') || hostname === 'localhost') {
        return 'http://10.10.1.1:5000/';
    }

    const protocol = window.location.protocol; // 'http:' или 'https:'
    return `${protocol}//cabinet.bga.gov.kg/`;
};

export const API_URL_BGA = getApiBaseUrlBga();
export const API_URL = getApiBaseUrl();
export const API_KEY_2GIS = readEnv('REACT_APP_2GIS_API_KEY', process.env.REACT_APP_2GIS_API_KEY)
    || '4a89e0a0-b65f-4495-8a60-a9c3327b63f9';

// --- Auth-флоу: плейсхолдеры и ссылки (вынесено из features/Auth, дехардкод) ---
// Дефолты = прежний хардкод → ПОВЕДЕНИЕ ЗАМОРОЖЕНО. Override через REACT_APP_* (см. .env.example).
// NB: это вынос значений, НЕ исправление дефектов. device-tracking всё так же не реализован
// (плейсхолдеры), help-URL остаётся http:// — баги чинятся отдельно под зелёной сетью.

// Заглушка USB-токена (симуляция ЭЦП в dev — реальной подписи нет)
export const AUTH_SIMULATED_TOKEN_ID = readEnv('REACT_APP_AUTH_SIMULATED_TOKEN_ID', process.env.REACT_APP_AUTH_SIMULATED_TOKEN_ID) || 'SIMULATED_TOKEN_123';
export const AUTH_SIMULATED_SIGNATURE = readEnv('REACT_APP_AUTH_SIMULATED_SIGNATURE', process.env.REACT_APP_AUTH_SIMULATED_SIGNATURE) || 'SIMULATED_SIGNATURE';

// Плейсхолдеры, отправляемые на бэк в токен-логине
export const AUTH_TOKEN_ID_PLACEHOLDER = readEnv('REACT_APP_AUTH_TOKEN_ID', process.env.REACT_APP_AUTH_TOKEN_ID) || '1';
export const AUTH_SIGNATURE_PLACEHOLDER = readEnv('REACT_APP_AUTH_SIGNATURE', process.env.REACT_APP_AUTH_SIGNATURE) || '2';
export const AUTH_DEVICE_ID = readEnv('REACT_APP_AUTH_DEVICE_ID', process.env.REACT_APP_AUTH_DEVICE_ID) || 'device_id';

// Внешние ссылки на форме логина
export const HELP_URL = readEnv('REACT_APP_HELP_URL', process.env.REACT_APP_HELP_URL) || 'http://cabinet.bga.gov.kg/help';
export const SUPPORT_URL = readEnv('REACT_APP_SUPPORT_URL', process.env.REACT_APP_SUPPORT_URL) || 'https://t.me/bga_ais_support';

// Публичный адрес портала: ссылка на заявку в QR-коде
export const PORTAL_PUBLIC_URL = (readEnv('REACT_APP_PORTAL_PUBLIC_URL', process.env.REACT_APP_PORTAL_PUBLIC_URL)
    || 'http://145.223.98.93:7011').replace(/\/+$/, '');

// Интервалы фонового опроса, мс
export const NOTIFICATIONS_POLL_MS = readEnvNumber('REACT_APP_NOTIFICATIONS_POLL_MS', process.env.REACT_APP_NOTIFICATIONS_POLL_MS, 25000);
export const APPLICATIONS_REFRESH_MS = readEnvNumber('REACT_APP_APPLICATIONS_REFRESH_MS', process.env.REACT_APP_APPLICATIONS_REFRESH_MS, 10000);
export const DASHBOARD_STATS_REFRESH_MS = readEnvNumber('REACT_APP_DASHBOARD_STATS_REFRESH_MS', process.env.REACT_APP_DASHBOARD_STATS_REFRESH_MS, 30000);

// Картографические сервисы
export const GIS_API_BASE_URL = (readEnv('REACT_APP_2GIS_API_BASE_URL', process.env.REACT_APP_2GIS_API_BASE_URL)
    || 'https://catalog.api.2gis.com/3.0').replace(/\/+$/, '');
export const GIS_GEO_BASE_URL = (readEnv('REACT_APP_2GIS_GEO_BASE_URL', process.env.REACT_APP_2GIS_GEO_BASE_URL)
    || 'https://2gis.kg/bishkek/geo').replace(/\/+$/, '');
export const MAP_OSM_TILE_URL = readEnv('REACT_APP_MAP_OSM_TILE_URL', process.env.REACT_APP_MAP_OSM_TILE_URL)
    || 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
export const MAP_SATELLITE_TILE_URL = readEnv('REACT_APP_MAP_SATELLITE_TILE_URL', process.env.REACT_APP_MAP_SATELLITE_TILE_URL)
    || 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}';

// Воркер pdf.js. По умолчанию — локальная legacy-сборка (public/pdf.worker.legacy.min.js,
// копируется scripts/copy-pdf-worker.js при start/build): она работает в iOS Safari < 18
// и старых Android, и её версия всегда совпадает с pdfjs-dist. Если переопределяете —
// указывайте legacy-воркер той же версии (…/pdfjs-dist@<версия>/legacy/build/pdf.worker.min.mjs).
export const PDF_WORKER_URL = readEnv('REACT_APP_PDF_WORKER_URL', process.env.REACT_APP_PDF_WORKER_URL)
    || `${process.env.PUBLIC_URL || ''}/pdf.worker.legacy.min.js`;
